export const getUserID = state => state.userID;
export const getCheckID = state => state.checkID;
export const getProfileID = state => state.profileID;



// WEBPACK FOOTER //
// ./src/redux/storage/selectors.js